
import categoryLib from "@/lib/category";
import participationLib from 'client/lib/participant'
import store from 'client/store'

import find from "lodash/find"

export default {
  /** get combined exercise configuration based on inherited configurations */
  configuration: function(exercise) {
    const participation = participationLib.getParticipation(exercise.participationId)
    const category = participationLib.getCategory(participation)
    const config = categoryLib.getConfiguration(category, exercise.roundIndex, exercise.exerciseTypeId)

    const catRound = category.rounds.find(r => r.roundIndex === exercise.roundIndex)
    if (catRound.config?.vaultCandidates && ! exercise.secondVault) {
      config.passes = 1
    }

    return config
  },

  getExercise: function(participationId, roundIndex, exerciseTypeId) {
    return find(store.state.exercises.items, item => item.participationId === participationId
          && item.roundIndex === roundIndex && item.exerciseTypeId === exerciseTypeId
    )
  }
};

